/**
 * Version information for flexcoa-client.
 * This file is automatically updated by the pre-push git hook.
 */

// Current version as an array [major, minor, patch]
export const VERSION = [0, 5, 533];


// Version string in format "X.Y.Z"
export const VERSION_STRING = VERSION.join('.');

/**
 * Returns the current version string.
 * @returns {string} Version string in format "X.Y.Z"
 */
export function getVersion() {
  return VERSION_STRING;
}

/**
 * Returns detailed version information.
 * @returns {Object} Version information object
 */
export function getVersionInfo() {
  return {
    version: VERSION_STRING,
    environment: import.meta.env.MODE || 'development',
  };
}
